import * as React from "react";
import axios from "axios";
import "../TagControl/TagControl.css";
import { successToastr, history } from "../../../HelperMethods";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";
import { includes } from "lodash";
import { allowedFileExtentions, allowedFileExtentionsContentLibrary,allowedMymeTypes,allowedMymeTypesContentLibrary } from "../../Shared/AppConstants";
import AlertBox from "../AlertBox";
import ConfirmationModal from "../ConfirmationModal";
import { FILE_UPLOAD_SUCCESS_MSG, FILE_UPLOAD_WAITING_MSG, REMOVE_TS_DOCUMENT_CONFIRMATION_MSG } from "../AppMessages";
import { hideLoader, showLoader } from "../../ReusableComponents";

export interface UploadDocumentsProps {
    entityId: any;
    entityName: any;
    fieldName: any;
    singleDoc?: boolean;
    isMultiPartUpload?: boolean;
    handlePropsChange?: any;
}

export interface UploadDocumentsState {
    fileArray?: any[];
    showInvalidFileAlert?: boolean;
    showRemoveModal?: boolean;
}

class UploadDocuments extends React.Component<UploadDocumentsProps, UploadDocumentsState> {
    invalidFileList: any[];
    globalFileId: any;
    alertMessage = "";
    uploadControl: HTMLInputElement;
    public fileArrayGlobal: any[];
    private userObj: any = JSON.parse(localStorage.getItem("user"));
    constructor(props: UploadDocumentsProps) {
        super(props);
        this.state = {
            fileArray: [],
        };
    }

    componentDidMount() {
        if (this.props.entityId != null) {
            this.getDocuments(this.props.entityId);
        }
    }

    getDocuments = (entityId) => {
        axios.get(`api/ts/documents?tsWeekId=${entityId}`).then((res:any) => {
            if (res.data) {
                let fileArray = [];
                res.data.forEach((doc) => {
                    fileArray.push({
                        candDocumentsId: doc.candDocumentsId,
                        fileName: doc.fileName,
                        file: undefined,
                        isValid: true,
                        path: doc.filePath,
                    });
                });
                this.setState({ fileArray: fileArray });
            }
        });
    };

    select = (event) => {
        let fileArray = [...this.state.fileArray];
        event.preventDefault();
        if (event.target.files.length > 0) {
            Array.from(event.target.files).forEach((file: any) => {
                if (this.props.entityName === "Content Library") {
                    const originalFileName = file.name;
                    const modifiedFileName = originalFileName.replace(/[+&]/g, '_');
                    file = new File([file], modifiedFileName, { type: file.type });
                }
                let isfileValid = false;
                if (includes(this.props.entityName === "Content Library" ? allowedMymeTypesContentLibrary : allowedMymeTypes, file.type)) {
                    isfileValid = true;
                } else if (file.type == "") {
                    if (includes(this.props.entityName === "Content Library" ? allowedFileExtentionsContentLibrary: allowedFileExtentions, file.name.split(".")[1])) {
                        isfileValid = true;
                    }
                }
                fileArray.push({ candDocumentsId: undefined, fileName: file.name, file: file, isValid: isfileValid, path: undefined });
            });
            this.fileArrayGlobal = fileArray;
            if (this.props.entityId == null || this.props.entityId == undefined) {
                this.setState({ fileArray: fileArray })
            }
            if (fileArray.some((d) => d.isValid === false)) {
                this.invalidFileList = fileArray.filter(x => x.isValid === false);
                this.alertMessage = this.extensionAlertMessage()
                this.setState({ showInvalidFileAlert: true });
                return false;
            }
            else if (this.props.entityId) {
                this.props.isMultiPartUpload ? this.uploadDocumentsToS3() : this.uploadDocuments();
            }
        }
    };

    extensionAlertMessage() {
        let alertMessage = this.invalidFileList.map(x => x.fileName).join(", ") + " is invalid and will not be uploaded. Supported extensions are "
                         + (this.props.entityName === "Content Library" ? allowedFileExtentionsContentLibrary.map(ext => "." + ext).join(", ") + "." : allowedFileExtentions.map(ext => "." + ext).join(", ") + ".");
        return alertMessage;
    }

    uploadDocuments = (entityId?) => {
        this.setState({ showInvalidFileAlert: false });
        let checkNewFile = this.fileArrayGlobal !== undefined ? this.fileArrayGlobal.filter((i) => i.candDocumentsId === undefined && i.isValid === true) : [];
        if (checkNewFile.length > 0) {
            let formData = new FormData();
            checkNewFile.map((item) => {
                formData.append("FormFiles", item.file);
            });
            formData.append("entityId", this.props.entityId ? this.props.entityId : entityId);
            formData.append("entityName", this.props.entityName);
            axios
                .post(`/api/ts/documents`, formData)
                .then((response) => response)
                .then((data) => {
                    if (this.props.entityId) {
                        successToastr("Document(s) uploaded successfully.");
                        this.getDocuments(this.props.entityId);
                    }
                });
        }
    }

    uploadDocumentsToS3 = async (entityId?, message?, redirectTo?) => {
        this.setState({ showInvalidFileAlert: false });
        let checkNewFile = this.fileArrayGlobal !== undefined ? this.fileArrayGlobal.filter((i) => i.candDocumentsId === undefined && i.isValid === true) : [];
        if (this.props.isMultiPartUpload == true && this.props.entityId) {
            if (checkNewFile.length > 0) {
                let id = this.props.entityId ? this.props.entityId : entityId;
                await this.multiPartUpload(checkNewFile[0].file, id, this.props.entityName);
                this.props.handlePropsChange(false);
                successToastr(FILE_UPLOAD_SUCCESS_MSG);
                this.getDocuments(this.props.entityId);
            }
        }
        else {
            if (checkNewFile.length > 0) {
                let id = this.props.entityId ? this.props.entityId : entityId;
                await this.multiPartUpload(checkNewFile[0].file, id, this.props.entityName);
                this.props.handlePropsChange(false);

                if (this.props.entityId) {
                    this.props.handlePropsChange(true);
                    successToastr(FILE_UPLOAD_SUCCESS_MSG);
                    this.props.handlePropsChange(false);
                    successToastr(message);
                    history.push(redirectTo);
                }   
                
            } else {
                if (message && redirectTo) {
                    successToastr(message);
                    history.push(redirectTo);
                }
            }
        }
    }

    async multiPartUpload(file, entityId, entityName) {
        const partSize = 5 * 1024 * 1024; // 5 MB
        const partCount = Math.ceil(file.size / partSize);
    
        // Initiate upload and get presigned URLs
        const initiateResponse = await axios.post('/api/document/initiatemultipartupload', {
            entityId: entityId,
            entityName: entityName,
            fileName: file.name,
            partCount: partCount
        });
    
        var uploadId= initiateResponse.data.item1;
        var urls= initiateResponse.data.item2;
        //const { uploadId, urls } = initiateResponse.data;
    
        let partETags = [];
        const instance = axios.create();
        showLoader();
        
        // Upload parts
        for (let i = 0; i < partCount; i++) {
          const start = i * partSize;
          const end = Math.min(start + partSize, file.size);
          const part = file.slice(start, end);
          const partNumber = i + 1;
          
          const response = await instance.put(urls[partNumber], part, {
            headers: {
              'Content-Type': file.type
            }
          });
    
          partETags.push({ ETag: response.headers.etag, PartNumber: partNumber });
        }

        hideLoader();

        // Complete the upload
        await axios.post('/api/document/completemultipartupload', {
            entityId: entityId,
            entityName: entityName,
            fileName: file.name,
            uploadId: uploadId,
            partETags: partETags
        });
    
      }

    download = (filePath) => {
        axios.get(`/api/candidates/documents/download?filePath=${filePath}`).then((res: any) => {
            if (res) {
                let fileExt = filePath.split('.')[1].toLowerCase();
                let fileType;
                if (fileExt == "jpg" || fileExt == "png" || fileExt == "jpeg") {
                    fileType = "image";
                } else {
                    fileType = "application";
                }
                const linkSource = `data:${fileType}/${fileExt};base64,${res.data}`;
                const downloadLink = document.createElement("a");
                let fileName = filePath.split("/")[2];

                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            }
        });
    };

    removeFile = (index) => {
        if (this.state.fileArray[index].candDocumentsId) {
            this.globalFileId = this.state.fileArray[index].candDocumentsId
            this.setState({ showRemoveModal: true })
        } else {
            let fileArray = this.state.fileArray;
            this.state.fileArray.splice(index, 1);
            this.setState({ fileArray: fileArray });
        }
    };

    deleteFile = () => {
        this.setState({ showRemoveModal: false });
        axios.delete(`/api/admin/documents/${this.globalFileId}`).then((res) => {
            successToastr("Document deleted successfully");
            this.getDocuments(this.props.entityId);
        });
    };

    checkDocLength = () => {
        let fileArray = [...this.state.fileArray];
        var isDocExist = fileArray.length > 0 ? true : false;
        var documentLength = fileArray.length;

        return { isDocExist, documentLength };
    }

    render() {
        return (
            <>
                <div>
                    <input
                        id="myInput"
                        type="file"
                        multiple
                        accept={this.props.entityName === "Content Library" ? "image/jpeg,image/png,application/pdf,video/mp4" : "image/jpeg,image/png,application/pdf,application/doc,application/docx,application/xls,application/xlsx,video/mp4"}
                        ref={(ref) => (this.uploadControl = ref)}
                        style={{ display: "none" }}
                        onChange={(e) => this.select(e)}
                    />
                    <label className="mb-0 font-weight-bold ">
                        {this.props.fieldName}
                        {this.props.singleDoc == true ?
                            this.state.fileArray.length == 0 &&
                            <span
                                onClick={() => {
                                    this.uploadControl.click();
                                }}
                                className="text-underline cursorElement align-middle"
                            >
                                <FontAwesomeIcon icon={faPaperclip} className="ml-1 active-icon-blue ClockFontSize" />
                            </span>
                            :
                            <span
                                onClick={() => {
                                    this.uploadControl.click();
                                }}
                                className="text-underline cursorElement align-middle"
                            >
                                <FontAwesomeIcon icon={faPaperclip} className="ml-1 active-icon-blue ClockFontSize" />
                            </span>
                        }
                    </label>
                    <div className="file-list">
                        {this.state.fileArray.length > 0 &&
                            this.state.fileArray.map((file, i) => (
                                <span>
                                    <span
                                        title={file.fileName}
                                        onClick={() => file.candDocumentsId && this.download(file.path)}
                                        className={file.isValid ? "valid-file" : "invalid-file"}
                                    >
                                        {file.fileName}
                                    </span>
                                    <span title="Remove" className="remove" onClick={() => this.removeFile(i)}>
                                        X
                                    </span>
                                </span>
                            ))}
                    </div>
                </div>
                <AlertBox
                    message={this.alertMessage}
                    showModal={this.state.showInvalidFileAlert}
                    handleNo={() => this.props.isMultiPartUpload ? this.uploadDocumentsToS3() : this.uploadDocuments()}
                />
                <ConfirmationModal
                    message={REMOVE_TS_DOCUMENT_CONFIRMATION_MSG()}
                    showModal={this.state.showRemoveModal}
                    handleYes={() => this.deleteFile()}
                    handleNo={() => {
                        this.setState({ showRemoveModal: false });
                    }}
                />
            </>
        );
    }
}

export default UploadDocuments;